export default {
  index: () => import('@v/Index'),
  'vue-routers/create': () => import('@v/vue-routers/Form'),
  'vue-routers': () => import('@v/vue-routers/Index'),
  'vue-routers/:id(\\d+)/edit': () => import('@v/vue-routers/Form'),

  'admin-permissions': () => import('@v/admin-permissions/Index'),
  'admin-permissions/create': () => import('@v/admin-permissions/Form'),
  'admin-permissions/:id(\\d+)/edit': () => import('@v/admin-permissions/Form'),

  'admin-roles': () => import('@v/admin-roles/Index'),
  'admin-roles/create': () => import('@v/admin-roles/Form'),
  'admin-roles/:id(\\d+)/edit': () => import('@v/admin-roles/Form'),

  'admin-users': () => import('@v/admin-users/Index'),
  'admin-users/create': () => import('@v/admin-users/Form'),
  'admin-users/:id(\\d+)/edit': () => import('@v/admin-users/Form'),

  'system-media': () => import('@v/system-media/Index'),

  'config-categories': () => import('@v/config-categories/Index'),

  configs: () => import('@v/configs/Index'),
  'configs/create': () => import('@v/configs/Form'),
  'configs/:id(\\d+)/edit': () => import('@v/configs/Form'),
  'configs/:categorySlug': () => import('@v/configs/ConfigValuesForm'),

  // 业务
  // 等级列表
  'user-levels': () => import('@v/user-levels/Index'),
  'user-levels/create': () => import('@v/user-levels/Form'),
  'user-levels/:id(\\d+)/edit': () => import('@v/user-levels/Form'),

  // 模版消息
  'wechat-templates': () => import('@v/wechat-templates/Index'),
  'wechat-templates/create': () => import('@v/wechat-templates/Form'),
  'wechat-templates/:id(\\d+)/edit': () => import('@v/wechat-templates/Form'),
  // 微信通知绑定
  'wechat-notify-binds': () => import('@v/wechat-notify-binds/Index'),
  'wechat-notify-binds/create': () => import('@v/wechat-notify-binds/Form'),
  'wechat-notify-binds/:id(\\d+)/edit': () => import('@v/wechat-notify-binds/Form'),
  // 意见反馈
  'feed-backs': () => import('@v/feed-backs/Index'),
  'feed-backs/create': () => import('@v/feed-backs/Form'),
  'feed-backs/:id(\\d+)/edit': () => import('@v/feed-backs/Form'),
  // 代理商列表
  users: () => import('@v/users/Index'),
  'users/create': () => import('@v/users/Register'), // 代注册
  'users/:id(\\d+)/edit': () => import('@v/users/Form'),

  // 种子邀请页
  'apply-all-agent': () => import('@v/apply-all-agent/Index'),
  // 盛塘基金池
  'stagent-funds': () => import('@v/stagent-funds/Index'),
  // 分红基金池
  funds: () => import('@v/funds/Index'),
  // 奖金列表
  'temp-rebates': () => import('@v/temp-rebates/Index'),
  // 充值审核
  'advance-recharges': () => import('@v/advance-recharges/Index'),
  'advance-logs': () => import('@v/advance-logs/Index'),
  // 用户变更日志
  'user-change-logs': () => import('@v/user-change-logs/Index'),
  // 商品列表
  goods: () => import('@v/goods/Index'),
  'goods/create': () => import('@v/goods/Form'),
  'goods/:id(\\d+)/edit': () => import('@v/goods/Form'),
  'goods/goods-sale-stats': () => import('@v/goods/goodsSaleStats'),

  // 运费模版
  'freight-templates': () => import('@v/freight-templates/Index'),
  // 订单列表
  orders: () => import('@v/orders/Index'),
  'orders/:id(\\d+)/edit': () => import('@v/orders/Form'), // 订单详情
  'orders/:id(\\d+)/print': () => import('@v/orders/Print'), // 订单打印

  // 线下订单列表
  'order-offline': () => import('@v/order-offline/Index'),
  'order-offline/create': () => import('@v/order-offline/Offline'), // 线下销售
  'order-offline/:id(\\d+)/edit': () => import('@v/order-offline/Form'), // 订单详情
  'order-offline/import': () => import('@v/order-offline/Import.vue'), // 订单导入
  'order-offline/:id(\\d+)/print': () => import('@v/order-offline/Print'), // 订单打印

  //报单审核
  'advice-applies': () => import('@v/advice-applies/Index'),
  // 提现列表
  withdrawals: () => import('@v/withdrawals/Index'),
  // 提现配置
  'withdrawal-cfgs': () => import('@v/withdrawal-cfgs/Index'),
  'withdrawal-cfgs/:id(\\d+)/edit': () => import('@v/withdrawal-cfgs/Form'),

  // 奖金变动日志
  'rebate-logs': () => import('@v/rebate-logs/Index'),

  // 销售日统计
  'sale-daily-stats': () => import('@v/sale-daily-stats/Index'),
  // 升级报单申请
  'user-level-applies': () => import('@v/user-level-applies/Index'),
  // 'user-level-applies/create': () => import('@v/user-level-applies/Form'), // TEST

  'sale-goods-daily-stats': () => import('@v/sale-goods-daily-stats/Index'), // 报单|复销日统计
  'sale-goods-monthly-stats': () => import('@v/sale-goods-monthly-stats/Index'), // 报单|复销月统计

  'fund-settlefk-logs': () => import('@v/fund-settlefk-logs/Index'), // 基金分红

  'base-configs': () => import('@v/base-configs/Index'),
  'base-configs/1/edit': () => import('@v/base-configs/Form'), // 全局配置

  downloads: () => import('@v/downloads/Index'),

  // 仓库管理
  warehouses: () => import('@v/warehouses/Index'),
  'warehouses/create': () => import('@v/warehouses/Form'),
  'warehouses/:id(\\d+)/edit': () => import('@v/warehouses/Form'),

  // 商品类型
  'goods-categories': () => import('@v/goods-categories/Index'),
  'goods-categories/create': () => import('@v/goods-categories/Form'),
  'goods-categories/:id(\\d+)/edit': () => import('@v/goods-categories/Form'),

  // 商品入库
  'in-storages': () => import('@v/in-storages/Index'),
  'in-storages/create': () => import('@v/in-storages/Form'),

  // 库存管理
  'warehouse-goods': () => import('@v/warehouse-goods/Index'),

  // 销售单导入
  'order-imports': () => import('@v/order-imports/Index'),

  // 销售单导入明细
  'order-import-details': () => import('@v/order-import-details/Index'),

  // 小票打印机设备管理
  'printer-devices': () => import('@v/printer-devices/Index'),
  'printer-devices/create': () => import('@v/printer-devices/Form'),
  'printer-devices/:id(\\d+)/edit': () => import('@v/printer-devices/Form'),
}
